import { render, staticRenderFns } from "./ClientRecurrence.vue?vue&type=template&id=2c3f9281&scoped=true&"
import script from "./ClientRecurrence.vue?vue&type=script&lang=js&"
export * from "./ClientRecurrence.vue?vue&type=script&lang=js&"
import style0 from "./ClientRecurrence.vue?vue&type=style&index=0&id=2c3f9281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f9281",
  null
  
)

export default component.exports